import styled from '@emotion/styled';
import { RiskReductionSvg } from 'images/shared';
import LabelSvg from 'images/renteoverzicht/label.svg';

const LogoLabels = styled.div`
  flex: 52px 1 1;

  display: flex;
  justify-content: space-around;
  align-items: center;

  box-sizing: border-box;
  padding: 0 8px;

  > div {
    display: flex;
    align-items: center;
    min-width: 16px;
    min-height: 16px;

    &:last-of-type {
      margin-left: 4px;
    }
  }

  span {
    display: none;
    margin-left: 16px;
    color: ${({ theme }) => theme.primaryColor};
  }

  svg, img {
    display: block;
    height: 16px;
    width: 16px;
    fill: ${({ theme }) => theme.primaryFontColor};

    &.active {
      fill: ${({ isPreferred, theme }) => isPreferred && theme.highlightColor};
    }
  }

  @media ${({ theme }) => theme.mobile} {
    flex: 48px 0 0;
    width: 100%;
    padding: 0 24px 24px;

    > div:empty {
      display: none;
    }

    span {
      display: block;
    }

    svg, img {
      height: 24px;
      width: 24px;
    }
  }
`;

const SortingLabels = ({ isPreferred, isFlexFront, input, result }) => (
  <LogoLabels {...{ isPreferred }}>
    <div>
      {result.collaboration && (
        <>
          {isFlexFront ? (
            <img
              src={'https://www.hypotheekbond.nl/images/logo/logo-flexfrontBal.png'}
              alt="FlexFront"
              title="FlexFront"
            />
          ) : (
            <LabelSvg className={input.prefer_collaboration ? 'active' : null} />
          )}
          <span>Ons product</span>
        </>
      )}
    </div>
    <div>
      {result.has_auto_risk_class_reduction && (
        <>
          <RiskReductionSvg className={input.prefer_auto_risk_class_reduction ? 'active' : null} />
          <span>Looptijdrente</span>
        </>
      )}
    </div>
  </LogoLabels>
);

export default SortingLabels;
